export const BASE_EMPLOYMENT = {};
